import { WpGlobe } from "./wpglobe/WpGlobe";
import { createEl } from "./wpglobe/utils";

const PIN_DATA = [
    {
        id: 1,
        title: "Europe",
        lat: "48.68594128410291",
        lng: "4.456041898601114",
        opportunities_count: 260,
        popup_text: "",
        thumb: "public/images/globe-europe.jpg",
        resource_url: "/template-jobs-region/",
    },
    {
        id: 2,
        title: "Africa",
        lat: "7.951220527879488",
        lng: "22.239322728086314",
        opportunities_count: 20,
        thumb: "public/images/globe-africa.jpg",
        popup_text: "",
        resource_url: "/template-jobs-region/",
    },
    {
        id: 3,
        title: "Asia",
        lat: "34.50720860551555",
        lng: "107.84479164016211",
        opportunities_count: 20,
        thumb: "public/images/globe-europe.jpg",
        popup_text: "",
        resource_url: "/template-jobs-region/",
    },
    {
        id: 4,
        title: "Australia",
        lat: "-23.6825284",
        lng: "133.8730793",
        opportunities_count: 5,
        popup_text: "",
        thumb: "public/images/globe-australia.jpg",
        resource_url: "/template-jobs-region/",
    },
    {
        id: 5,
        title: "America",
        lat: "37.6792434",
        lng: "-97.2710035",
        opportunities_count: 5,
        popup_text: "",
        thumb: "public/images/globe-australia.jpg",
        resource_url: "/template-jobs-region/",
    },
];

const HIGHLIGHTED_COUNTRIES = [
    "AU",
    "US",
    "UY",
    "BR",
    "GT",
    "HN",
    "NI",
    "CR",
    "JP",
    "KR",
    "CN",
    "NA",
    "ZA",
    "NG",
    "HK",
    "IT",
    "FR",
    "SG",
    "VN",
    "AE",
    "DK",
    "DE",
    "ES",
];

function globeInit() {
    const globeContainer = document.getElementById("wpglobe-container");
    if (!globeContainer) return;

    window.globe = new WpGlobe(globeContainer, {
        pinData: PIN_DATA,
        highlightedCountries: HIGHLIGHTED_COUNTRIES,
        countriesGeoJsonUrl: "/dist/countries.geojson",
        autoAnimate: true,
        pinPopupCloseBtnEnabled: false,
        autoAnimateDuration: 6000,
        idleDuration: 6000,
        flyToAltitude: 2.8,
        flyToAltitudeMobile: 2.8,
        atmosphereAltitude: 0.001,
        hexPolygonResolution: 3,
        hexPolygonMargin: 0.5,
        hexPolygonAltitude: 0.001,
        pinIconSelected: 2,
        hexPolygonColor: "#BDB2AD",
        countryHighlightColor: "#f26722",
        pinColor: "#ff5c00",
        pinActiveColor: "#ff5c00",
        globeMaterialPolygons: {
            color: "#d7d7d7",
            shininess: 0,
            transparent: true,
            opacity: 0,
        },
        controls: {
            enableZoom: false,
            enablePan: true,
            enableRotate: true,
        },
        createPopupHTML: pin => {
            const el = createEl("div", null, { className: "card--globe" });
            const el_inner = createEl("div", null, { className: "card-globe__inner" });
            const el_content = createEl("div", null, { className: "card-globe__content" });
            const el_imagewrap = createEl("div", null, { className: "card-globe__image-wrap" });
            const el_readmore = createEl("div", ``, { className: "card-globe__readmore" });

            const thumb = createEl("div", `<img width="50" height="50" alt="Alt goes here" src='${pin.thumb}' />`, {
                className: "card-globe__image",
            });

            const content = createEl("div", `<p class='card-globe__title'>${pin.title}</p>`, {
                className: "map-pin-popup__content",
            });

            el_imagewrap.append(thumb);
            el_content.append(content);
            el_inner.append(el_imagewrap, el_content);
            el.append(el_readmore, el_inner);

            return el;
        },
    });
}

globeInit();
